module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av111-a51ef0a4a8dba7c4c572d3ff1a7f062f.jpg";